import _ from 'lodash';
import { toast } from 'react-toastify';
import { events } from 'domain-model';
import { SOCKET, SOCKET_LOG_INFO } from 'flaivy-react/reducers/action-type';
const LOG_LIMIT = 30;

const initialState = {
  events: [],
};

const isLogEvent = type => {
  return type.endsWith(SOCKET('')) || type.endsWith(SOCKET_LOG_INFO(''));
};

const reducer = (state = initialState, action) => {
  if (isLogEvent(action.type)) {
    const event = action.payload;
    event.key = _.uniqueId();

    if (event.userId === event.loggedInUser.id) {
      toast(events.prettierEventNames(event), {
        type: event.error ? toast.TYPE.ERROR : toast.TYPE.INFO,
        autoClose: !event.error,
      });
    }

    return {
      ...state,
      events: _.take(_.concat([event], state.events), LOG_LIMIT),
    };
  }
  return state;
};

export default reducer;
